import {TaskResponse} from './task-response';

export class OrderCancelTaskResponse extends TaskResponse {

  generateRevision!: boolean;

}
